import React from 'react'
import UserResults from '../Components/users/UserResults'
import UserSearch from '../Components/users/UserSearch'
export default function Home() {
  return (
    <>
   <UserSearch/>
    <UserResults/>
    </>
  )
}
